import { MessageSeverity } from "../../utils/lib/messageSeverity";

type SnackbarFn = (
  message: string,
  severity: MessageSeverity,
  duration?: number
) => void;

let snackbarFn: SnackbarFn | null = null;

export const setSnackbarHandler = (fn: SnackbarFn) => {
  snackbarFn = fn;
};

export const showSnackbar = (
  message: string,
  severity: MessageSeverity = MessageSeverity.Success,
  duration?: number
) => {
  if (snackbarFn) {
    snackbarFn(message, severity, duration);
  } else {
    console.warn("Snackbar not initialized yet");
  }
};
